var ProfileModule = (function () {
    function ProfileModule() {
    }
    return ProfileModule;
}());
export { ProfileModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile.module.ts.pre-build-optimizer.js